import { createSlice } from '@reduxjs/toolkit';
import {
    companySearch,
    companyDetail
}  from '../actions/companySearch';

export const companySearchSlice = createSlice({
    name: 'companySearch',
    initialState: {
        loading: false,
        companies: [],
        currentLoading: false,
        current: {},
        error: null
    },
    reducers: {
        resetCompanySearch: (state) => {
            state.companies = [];
            state.current = {};
        }
    },
    extraReducers:(builder) => {
        builder
        // Search companies
        .addCase(companySearch.pending, (state) => {
            state.loading = true;
            state.companies = [];
        })
        .addCase(companySearch.fulfilled,(state, action) => { 
            state.loading = false;
            state.companies = action.payload
        })
        .addCase(companySearch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message || 'Chyba pri vyhľadávaní spoločnosti';
        })
         // Company detail
         .addCase(companyDetail.pending,(state) => { state.currentLoading = true })
         .addCase(companyDetail.fulfilled,(state, action) => { 
             state.currentLoading = false;
             state.current = action.payload
         })
         .addCase(companyDetail.rejected, (state) => { state.currentLoading = false  })
    }
});

export const { resetCompanySearch } = companySearchSlice.actions;
export default companySearchSlice.reducer;